module.exports = __webpack_public_path__ + "static/campaign-2-0b17bbf5be0cba11bbc35aff37297ee2.png";